// extracted by mini-css-extract-plugin
module.exports = {"space1":"1px","space12":"12px","space36":"36px","space72":"72px"};